import { BACKDROP_CONSTANTS, BACKDROP_TYPES } from './constants';

export const showBackdrop = ({ type: nextType = BACKDROP_TYPES.PRELOADER, reason } = {}) => ({
  type: BACKDROP_CONSTANTS.SHOW_BACKDROP, payload: { shownAt: Date.now(), type: nextType, reason },
});

export const hideBackdrop = ({ minDisplayTime = 0, reason, callback = () => {} } = {}) => (dispatch, getState) => {
  const { backdrop: { shownAt } } = getState();

  const displayTime = Date.now() - (shownAt ?? 0);

  const action = { type: BACKDROP_CONSTANTS.HIDE_BACKDROP, payload: { reason } };
  if (displayTime >= minDisplayTime) {
    dispatch(action);
    callback();
  } else {
    setTimeout(() => {
      dispatch(action);
      callback();
    }, minDisplayTime - displayTime);
  }
};

export const hideBackdropImmediately = ({ type: BACKDROP_CONSTANTS.HIDE_BACKDROP_IMMEDIATELY });
